import React from 'react';

import { useStatementContext } from './StatementContext';
import { PayableWrapper } from './StatementPayable';
import { ReceivableWrapper } from './StatementReceivable';

/**
 * StatementWrapper
 *
 * Universal wrapper component for statements.
 * Handles the logic and rendering for all contact types (model, client, agency, service).
 * Renders different wrappers based on whether it's a payable or receivable statement.
 *
 * Replaces:
 * - ModelStatementWrapper
 * - ClientStatementWrapper
 * - AgencyStatementWrapper
 * - ServiceStatementWrapper
 */
const StatementWrapper = ({ statement, payments, isPayable, isLoading }) => {
    const { contactType, statementType } = useStatementContext();

    // Determine which wrapper to render based on isPayable flag
    if (isPayable) {
        // Account Payable - supplier statement (model, agency, service as suppliers)
        // Uses the full wrapper with all filters and features
        return <PayableWrapper statement={statement} payments={payments} isLoading={isLoading} />;
    } else {
        // Account Receivable - client statement
        return <ReceivableWrapper statement={statement} isLoading={isLoading} />;
    }
};

export default StatementWrapper;
